export const CONSUMER_SEARCH_BRANDS_REDIRECTS = {
  'number-nine': 'number-n-ine',
  'dolce-gabbana': 'dolce-and-gabbana',
  'bricks-wood': 'bricks-and-wood',
  'sporty-rich': 'sporty-and-rich',
  'mitchell-ness': 'mitchell-and-ness',
  'sr-studio-la-ca': 's-r-studio-la-ca',
  'museum-of-peace-quiet': 'museum-of-peace-and-quiet',
  'cp-company': 'c-p-company',
  yproject: 'y-project',
  '3paradis': '3-paradis',
  apc: 'a-p-c',
  'tiffany-co': 'tiffany-and-co',
  'van-cleef-arpels': 'van-cleef-and-arpels',
  placesfaces: 'places-faces',
  'if-co': 'if-and-co',
  bline: 'b-line',
  nhoolywood: 'n-hoolywood',
  tradition: 'andtradition',
  'porter-yoshida-co': 'porter-yoshida-and-co',
  juunj: 'juun-j',
  hdm: 'handdm',
  'han-kjbenhavn': 'han-kjobenhavn',
  'master-dynamic': 'master-and-dynamic',
  redone: 're-done',
  pam: 'p-a-m',
  'be-rbrick': 'bearbrick',
  beatrbrick: 'bearbrick',
};

//  this is correcting frontend slugs to match consumer search slugs
export const CONSUMER_SEARCH_BRANDS_SLUG_CORRECTIONS = {
  bearbrick: 'beatrbrick',
  'be-rbrick': 'beatrbrick',
};

export const CONSUMER_SEARCH_BRANDS_PRESENTATION = {
  beatrbrick: 'BE@RBRICK',
  bearbrick: 'BE@RBRICK',
};

export const CONSUMER_SEARCH_SILHOUETTES_REDIRECTS = {
  '3st001': '3st-001',
  '3st002': '3st-002',
  '3st003': '3st-003',
  '3st004': '3st-004',
  '5740': '57-40',
  'acg-moc-35': 'acg-moc-3-5',
  'adilette-clog-20': 'adilette-clog-2-0',
  'adizero-prime-sp-20': 'adizero-prime-sp-2-0',
  'adizero-select-20': 'adizero-select-2-0',
  'air-force-11': 'air-force-1-1',
  'air-jordan-185': 'air-jordan-18-5',
  'air-jordan-95': 'air-jordan-9-5',
  'air-max-tl-25': 'air-max-tl-2-5',
  'balenciaga-track2': 'balenciaga-track-2',
  cp3ii: 'cp3-ii',
  cp3iii: 'cp3-iii',
  cp3v: 'cp3-v',
  cp3vi: 'cp3-vi',
  cp3vii: 'cp3-vii',
  cp3x: 'cp3-x',
  'dmsx-distorted-dna': 'd-ms-x-distorted-dna',
  'don-issue-1': 'd-o-n-issue-1',
  'don-issue-2': 'd-o-n-issue-2',
  'don-issue-3': 'd-o-n-issue-3',
  'don-issue-4': 'd-o-n-issue-4',
  'don-issue-5': 'd-o-n-issue-5',
  'don-issue-6': 'd-o-n-issue-6',
  'don-issue-7': 'd-o-n-issue-7',
  'd-rose-15': 'd-rose-1-5',
  'd-rose-35': 'd-rose-3-5',
  'd-rose-45': 'd-rose-4-5',
  'dior-diorevolution-slide': 'dior-dio-r-evolution-slide',
  'dolce-gabbana-air-master': 'dolce-and-gabbana-air-master',
  'dolce-gabbana-daymaster': 'dolce-and-gabbana-daymaster',
  'dolce-gabbana-ns1': 'dolce-and-gabbana-ns1',
  'dolce-gabbana-portofino': 'dolce-and-gabbana-portofino',
  'dolce-gabbana-slides': 'dolce-and-gabbana-slides',
  'dolce-gabbana-sorrento-melt': 'dolce-and-gabbana-sorrento-melt',
  'dolce-gabbana-space': 'dolce-and-gabbana-space',
  'dolce-gabbana-super-king': 'dolce-and-gabbana-super-king',
  'dolce-gabbana-super-queen': 'dolce-and-gabbana-super-queen',
  'eqt-support-9317': 'eqt-support-93-17',
  f13: 'f-1-3',
  f22: 'f-22',
  'free-trainer-10': 'free-trainer-1-0',
  'future-z-11': 'future-z-1-1',
  hst20: 'h-st-20',
  'harden-be': 'harden-b-e',
  'hoops-20': 'hoops-2-0',
  'hoops-30': 'hoops-3-0',
  'huarache-edge': 'huarache-e-d-g-e',
  'jeremy-scott-wings-20': 'jeremy-scott-wings-2-0',
  'jordan-125-team': 'jordan-12-5-team',
  'jordan-25-team': 'jordan-2-5-team',
  'jordan-bfly': 'jordan-b-fly',
  'jordan-flight-95': 'jordan-flight-9-5',
  'jordan-melo-55': 'jordan-melo-5-5',
  'jordan-retro-v1': 'jordan-retro-v-1',
  'jordan-superfly': 'jordan-super-fly',
  'jordan-superfly-2': 'jordan-super-fly-2',
  'jordan-superfly-2017': 'jordan-super-fly-2017',
  'jordan-superfly-3': 'jordan-super-fly-3',
  'jordan-superfly-4': 'jordan-super-fly-4',
  'jordan-superfly-5': 'jordan-super-fly-5',
  'jordan-superfly-mvp': 'jordan-super-fly-mvp',
  'jordan-superfly-team-slide': 'jordan-super-fly-team-slide',
  'jordan-system23': 'jordan-system-23',
  'jordan-two3-r-b': 'jordan-two3-r-and-b',
  'jordan-ultrafly': 'jordan-ultra-fly',
  'jordan-ultrafly-2': 'jordan-ultra-fly-2',
  'jordan-ultrafly-3': 'jordan-ultra-fly-3',
  'jordan-v5': 'jordan-v-5',
  'jordan-why-not-zer03': 'jordan-why-not-zer0-3',
  'jordan-why-not-zer04': 'jordan-why-not-zer0-4',
  'jordan-why-not-zer05': 'jordan-why-not-zer0-5',
  'jordan-why-not-zer06': 'jordan-why-not-zer0-6',
  'kobe-ad': 'kobe-a-d',
  'kobe-ad-2018': 'kobe-a-d-2018',
  'kobe-ad-nxt': 'kobe-a-d-nxt',
  'kobe-ad-nxt-360': 'kobe-a-d-nxt-360',
  'louis-vuitton-vnr': 'louis-vuitton-v-n-r',
  mb01: 'mb-01',
  mb02: 'mb-02',
  mb03: 'mb-03',
  mb04: 'mb-04',
  'melo-15': 'melo-1-5',
  'melo-55': 'melo-5-5',
  'messi-162': 'messi-16-2',
  n92: 'n-92',
  'n110-dmsx': 'n110-d-ms-x',
  'off-white-50': 'off-white-5-0',
  'offline-30-mule': 'offline-3-0-mule',
  'pod-s31': 'p-o-d-s3-1',
  'pg-25': 'pg-2-5',
  'predator-181': 'predator-18-1',
  'predator-accuracy1': 'predator-accuracy-1',
  'predator-freak1': 'predator-freak-1',
  'signal-dmsx': 'signal-d-ms-x',
  'vapor-jet-42': 'vapor-jet-4-2',
  'x-181': 'x-18-1',
  'x-speedflow1': 'x-speedflow-1',
  'xt-pure-advanced': 'xt-pu-re-advanced',
  'zig-kinetica-25-edge': 'zig-kinetica-2-5-edge',
  'zoom-paul-rodriguez-25': 'zoom-paul-rodriguez-2-5',
  'zoom-tre-ad': 'zoom-tre-a-d',
  'zoom-vapor-95': 'zoom-vapor-9-5',
};

export const CONSUMER_SEARCH_BRANDS_REVERSE_REDIRECTS = {
  'number-n-ine': 'number-nine',
  'dolce-and-gabbana': 'dolce-gabbana',
  'bricks-and-wood': 'bricks-wood',
  'sporty-and-rich': 'sporty-rich',
  'mitchell-and-ness': 'mitchell-ness',
  's-r-studio-la-ca': 'sr-studio-la-ca',
  'museum-of-peace-and-quiet': 'museum-of-peace-quiet',
  'c-p-company': 'cp-company',
  'y-project': 'yproject',
  '3-paradis': '3paradis',
  'a-p-c': 'apc',
  'tiffany-and-co': 'tiffany-co',
  'van-cleef-and-arpels': 'van-cleef-arpels',
  'places-faces': 'placesfaces',
  'if-and-co': 'if-co',
  'b-line': 'bline',
  'n-hoolywood': 'nhoolywood',
  andtradition: 'tradition',
  'porter-yoshida-and-co': 'porter-yoshida-co',
  'juun-j': 'juunj',
  handdm: 'hdm',
  'han-kjobenhavn': 'han-kjbenhavn',
  'master-and-dynamic': 'master-dynamic',
  're-done': 'redone',
  'p-a-m': 'pam',
  'be-rbrick': 'bearbrick',
  beatrbrick: 'bearbrick',
};

export const CONSUMER_SEARCH_SILHOUETTES_REVERSE_REDIRECTS = {
  '3st-001': '3st001',
  '3st-002': '3st002',
  '3st-003': '3st003',
  '3st-004': '3st004',
  '57-40': '5740',
  'acg-moc-3-5': 'acg-moc-35',
  'adilette-clog-2-0': 'adilette-clog-20',
  'adizero-prime-sp-2-0': 'adizero-prime-sp-20',
  'adizero-select-2-0': 'adizero-select-20',
  'air-force-1-1': 'air-force-11',
  'air-jordan-18-5': 'air-jordan-185',
  'air-jordan-9-5': 'air-jordan-95',
  'air-max-tl-2-5': 'air-max-tl-25',
  'balenciaga-track-2': 'balenciaga-track2',
  'cp3-ii': 'cp3ii',
  'cp3-iii': 'cp3iii',
  'cp3-v': 'cp3v',
  'cp3-vi': 'cp3vi',
  'cp3-vii': 'cp3vii',
  'cp3-x': 'cp3x',
  'd-ms-x-distorted-dna': 'dmsx-distorted-dna',
  'd-o-n-issue-1': 'don-issue-1',
  'd-o-n-issue-2': 'don-issue-2',
  'd-o-n-issue-3': 'don-issue-3',
  'd-o-n-issue-4': 'don-issue-4',
  'd-o-n-issue-5': 'don-issue-5',
  'd-o-n-issue-6': 'don-issue-6',
  'd-o-n-issue-7': 'don-issue-7',
  'd-rose-1-5': 'd-rose-15',
  'd-rose-3-5': 'd-rose-35',
  'd-rose-4-5': 'd-rose-45',
  'dior-dio-r-evolution-slide': 'dior-diorevolution-slide',
  'dolce-and-gabbana-air-master': 'dolce-gabbana-air-master',
  'dolce-and-gabbana-daymaster': 'dolce-gabbana-daymaster',
  'dolce-and-gabbana-ns1': 'dolce-gabbana-ns1',
  'dolce-and-gabbana-portofino': 'dolce-gabbana-portofino',
  'dolce-and-gabbana-slides': 'dolce-gabbana-slides',
  'dolce-and-gabbana-sorrento-melt': 'dolce-gabbana-sorrento-melt',
  'dolce-and-gabbana-space': 'dolce-gabbana-space',
  'dolce-and-gabbana-super-king': 'dolce-gabbana-super-king',
  'dolce-and-gabbana-super-queen': 'dolce-gabbana-super-queen',
  'eqt-support-93-17': 'eqt-support-9317',
  'f-1-3': 'f13',
  'f-22': 'f22',
  'free-trainer-1-0': 'free-trainer-10',
  'future-z-1-1': 'future-z-11',
  'h-st-20': 'hst20',
  'harden-b-e': 'harden-be',
  'hoops-2-0': 'hoops-20',
  'hoops-3-0': 'hoops-30',
  'huarache-e-d-g-e': 'huarache-edge',
  'jeremy-scott-wings-2-0': 'jeremy-scott-wings-20',
  'jordan-12-5-team': 'jordan-125-team',
  'jordan-2-5-team': 'jordan-25-team',
  'jordan-b-fly': 'jordan-bfly',
  'jordan-flight-9-5': 'jordan-flight-95',
  'jordan-melo-5-5': 'jordan-melo-55',
  'jordan-retro-v-1': 'jordan-retro-v1',
  'jordan-super-fly': 'jordan-superfly',
  'jordan-super-fly-2': 'jordan-superfly-2',
  'jordan-super-fly-2017': 'jordan-superfly-2017',
  'jordan-super-fly-3': 'jordan-superfly-3',
  'jordan-super-fly-4': 'jordan-superfly-4',
  'jordan-super-fly-5': 'jordan-superfly-5',
  'jordan-super-fly-mvp': 'jordan-superfly-mvp',
  'jordan-super-fly-team-slide': 'jordan-superfly-team-slide',
  'jordan-system-23': 'jordan-system23',
  'jordan-two3-r-and-b': 'jordan-two3-r-b',
  'jordan-ultra-fly': 'jordan-ultrafly',
  'jordan-ultra-fly-2': 'jordan-ultrafly-2',
  'jordan-ultra-fly-3': 'jordan-ultrafly-3',
  'jordan-v-5': 'jordan-v5',
  'jordan-why-not-zer0-3': 'jordan-why-not-zer03',
  'jordan-why-not-zer0-4': 'jordan-why-not-zer04',
  'jordan-why-not-zer0-5': 'jordan-why-not-zer05',
  'jordan-why-not-zer0-6': 'jordan-why-not-zer06',
  'kobe-a-d': 'kobe-ad',
  'kobe-a-d-2018': 'kobe-ad-2018',
  'kobe-a-d-nxt': 'kobe-ad-nxt',
  'kobe-a-d-nxt-360': 'kobe-ad-nxt-360',
  'louis-vuitton-v-n-r': 'louis-vuitton-vnr',
  'mb-01': 'mb01',
  'mb-02': 'mb02',
  'mb-03': 'mb03',
  'mb-04': 'mb04',
  'melo-1-5': 'melo-15',
  'melo-5-5': 'melo-55',
  'messi-16-2': 'messi-162',
  'n-92': 'n92',
  'n110-d-ms-x': 'n110-dmsx',
  'off-white-5-0': 'off-white-50',
  'offline-3-0-mule': 'offline-30-mule',
  'p-o-d-s3-1': 'pod-s31',
  'pg-2-5': 'pg-25',
  'predator-18-1': 'predator-181',
  'predator-accuracy-1': 'predator-accuracy1',
  'predator-freak-1': 'predator-freak1',
  'signal-d-ms-x': 'signal-dmsx',
  'vapor-jet-4-2': 'vapor-jet-42',
  'x-18-1': 'x-181',
  'x-speedflow-1': 'x-speedflow1',
  'xt-pu-re-advanced': 'xt-pure-advanced',
  'zig-kinetica-2-5-edge': 'zig-kinetica-25-edge',
  'zoom-paul-rodriguez-2-5': 'zoom-paul-rodriguez-25',
  'zoom-tre-a-d': 'zoom-tre-ad',
  'zoom-vapor-9-5': 'zoom-vapor-95',
};

export const CONSUMER_SEARCH_NEW_SILHOUETTES = {
  'x-plrpath': 'x_plrpath',
  'nmd-g1': 'nmd_g1',
  'nmd-c1': 'nmd_c1',
  'u-path': 'u_path',
};
